import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Timer, Layers } from "lucide-react";

export function RestakeNotice({ user }) {
  const [left, setLeft] = React.useState(user?.restake_seconds_left ?? 0);
  React.useEffect(() => {
    setLeft(user?.restake_seconds_left ?? 0);
  }, [user?.restake_seconds_left]);
  React.useEffect(() => {
    if (left <= 0) return;
    const t = setInterval(() => setLeft((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, [left > 0]);

  if (!user) return null;

  // Permanently inactive: missed the 48h window
  if (user.inactive) {
    return (
      <div className="rounded-2xl border border-red-500/40 bg-red-500/[0.07] p-5 mb-6 flex items-center justify-between flex-wrap gap-4" data-testid="restake-inactive-banner">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-red-500/15 border border-red-500/30 grid place-items-center shrink-0">
            <AlertTriangle className="w-5 h-5 text-red-400" />
          </div>
          <div>
            <div className="font-display font-bold text-red-300 text-base">Your ID is INACTIVE</div>
            <p className="text-xs text-red-200/70 mt-0.5 max-w-xl">
              Your 48-hour restake window expired without a new stake, so your position was withdrawn and all income is paused.
              Contact an admin to reactivate your ID.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (!left || left <= 0) return null;

  const h = Math.floor(left / 3600);
  const m = Math.floor((left % 3600) / 60);
  const s = left % 60;
  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div className="rounded-2xl border border-[#D4AF37]/40 bg-[#D4AF37]/[0.06] p-5 mb-6 flex items-center justify-between flex-wrap gap-4" data-testid="restake-countdown-banner">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl bg-[#D4AF37]/15 border border-[#D4AF37]/30 grid place-items-center shrink-0">
          <Timer className="w-5 h-5 gold-text" />
        </div>
        <div>
          <div className="font-display font-bold text-white text-base">Restake window open — don't lose your ID!</div>
          <p className="text-xs text-muted-foreground mt-0.5 max-w-xl">
            You claimed a Flash Snap (24h) stake. Re-stake within the countdown to stay active — if it hits zero,
            your position is withdrawn and your ID goes inactive.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div className="font-num font-black text-2xl gold-text tabular-nums" data-testid="restake-countdown-timer">
          {pad(h)}:{pad(m)}:{pad(s)}
        </div>
        <Link to="/buy" data-testid="restake-now-btn" className="flex items-center gap-2 rounded-xl bg-[#1CFD4C] px-4 py-2.5 font-semibold text-[#050806] hover:bg-[#4DFF74] transition-colors">
          <Layers className="w-4 h-4" /> Re-Stake Now
        </Link>
      </div>
    </div>
  );
}
